var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 330,
    viewBox: "0 0 323 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 320,
    height: 327,
    fill: "url(#paint0_linear_908_1761)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.028 52.8901L277.735 138.985L282.836 136.04L231.429 47L128.614 47L128.614 52.8901L228.028 52.8901Z",
    fill: "url(#paint1_linear_908_1761)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.76 165.001L220.631 267.416L102.372 267.416L43.2427 165.001L102.372 62.5859L220.631 62.5859L279.76 165.001ZM217.23 68.4761L105.773 68.4761L50.0441 165.001L105.773 261.526L217.23 261.526L272.958 165.001L217.23 68.4761Z",
    fill: "url(#paint2_linear_908_1761)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9748 277.111L194.389 277.111L194.389 283.001L91.5742 283.001L40.1669 193.961L45.2679 191.016L94.9748 277.111Z",
    fill: "url(#paint3_linear_908_1761)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.164 165.001L209.833 248.712L113.172 248.712L64.8414 165.001L113.172 81.29L209.833 81.29L258.164 165.001ZM206.433 87.1802L116.573 87.1802L71.6428 165.001L116.573 242.822L206.433 242.822L251.363 165.001L206.433 87.1802Z",
    fill: "url(#paint4_linear_908_1761)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M201.75 164.019L181.134 199.726L139.903 199.726L119.288 164.019L139.903 128.312L181.134 128.312L201.75 164.019Z",
    fill: "url(#paint5_linear_908_1761)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.152 164.018L182.836 202.671L138.205 202.671L115.889 164.018L138.205 125.366L182.836 125.366L205.152 164.018ZM179.436 131.256L141.605 131.256L122.69 164.018L141.605 196.78L179.436 196.78L198.351 164.018L179.436 131.256Z",
    fill: "url(#paint6_linear_908_1761)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.519 106.099C128.531 106.099 102.599 132.031 102.599 164.019C102.599 196.007 128.531 221.939 160.519 221.939C192.507 221.939 218.439 196.007 218.439 164.019C218.439 132.031 192.507 106.099 160.519 106.099ZM96.709 164.019C96.709 128.778 125.278 100.209 160.519 100.209C195.76 100.209 224.329 128.778 224.329 164.019C224.329 199.26 195.76 227.829 160.519 227.829C125.278 227.829 96.709 199.26 96.709 164.019Z",
    fill: "url(#paint7_angular_908_1761)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.188 100.748C154.916 100.392 157.697 100.209 160.519 100.209C161.296 100.209 162.07 100.223 162.84 100.25L162.63 106.137C161.929 106.112 161.226 106.099 160.519 106.099C157.952 106.099 155.426 106.266 152.95 106.589L152.188 100.748ZM167.473 100.584C168.245 100.668 169.014 100.765 169.778 100.876L168.93 106.705C168.237 106.604 167.539 106.516 166.838 106.44L167.473 100.584ZM121.671 113.394C126.061 110.02 130.903 107.204 136.092 105.052L138.349 110.493C133.642 112.445 129.246 115.001 125.26 118.064L121.671 113.394ZM101.552 139.592C103.704 134.403 106.52 129.561 109.894 125.171L114.564 128.76C111.501 132.746 108.945 137.142 106.993 141.849L101.552 139.592ZM96.709 164.019C96.709 161.197 96.8924 158.416 97.2482 155.688L103.089 156.45C102.766 158.926 102.599 161.452 102.599 164.019C102.599 166.586 102.766 169.112 103.089 171.587L97.2482 172.349C96.8924 169.622 96.709 166.841 96.709 164.019ZM220.194 186.661C219.046 189.684 217.676 192.597 216.103 195.38L210.975 192.481C212.403 189.956 213.646 187.313 214.687 184.571L220.194 186.661ZM109.894 202.867C106.52 198.477 103.704 193.635 101.552 188.445L106.993 186.189C108.945 190.896 111.501 195.291 114.564 199.278L109.894 202.867ZM204.252 210.486C199.593 214.872 194.274 218.566 188.457 221.403L185.875 216.109C191.153 213.535 195.983 210.181 200.214 206.197L204.252 210.486ZM136.092 222.986C130.903 220.834 126.061 218.018 121.671 214.644L125.26 209.974C129.246 213.037 133.642 215.593 138.349 217.545L136.092 222.986ZM170.118 227.111C166.986 227.584 163.78 227.829 160.519 227.829C157.697 227.829 154.916 227.645 152.188 227.29L152.95 221.449C155.426 221.772 157.952 221.939 160.519 221.939C163.485 221.939 166.397 221.716 169.239 221.287L170.118 227.111Z",
    fill: "url(#paint8_linear_908_1761)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.117 164.018L171.319 182.722L149.721 182.722L138.923 164.018L149.721 145.314L171.319 145.314L182.117 164.018Z",
    fill: "#3AEFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.518 164.019L173.019 185.668L148.021 185.668L135.522 164.019L148.021 142.37L173.019 142.37L185.518 164.019ZM169.618 148.26L151.421 148.26L142.323 164.019L151.421 179.778L169.618 179.778L178.716 164.019L169.618 148.26Z",
    fill: "url(#paint9_linear_908_1761)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.573 100.211C203.002 101.44 224.331 134.683 224.331 164.019V166.965L180.154 166.965V161.074L218.363 161.074C217 135.029 197.658 107.17 162.395 106.098L162.573 100.211Z",
    fill: "url(#paint10_linear_908_1761)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.409 164.019C166.409 167.272 163.772 169.909 160.519 169.909C157.266 169.909 154.629 167.272 154.629 164.019C154.629 160.766 157.266 158.129 160.519 158.129C163.772 158.129 166.409 160.766 166.409 164.019Z",
    fill: "url(#paint11_linear_908_1761)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 320,
    height: 327,
    stroke: "#D3DEFB",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_1761",
    x1: 396.756,
    y1: 0.0000160772,
    x2: 117.126,
    y2: 311.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_1761",
    x1: 142.08,
    y1: 49.9451,
    x2: 145.388,
    y2: 139.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_1761",
    x1: 64.2419,
    y1: 62.5859,
    x2: 75.8288,
    y2: 271.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_1761",
    x1: 200.77,
    y1: 292.621,
    x2: 167.67,
    y2: 169.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_908_1761",
    x1: 82.0056,
    y1: 81.29,
    x2: 91.4764,
    y2: 251.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_908_1761",
    x1: 126.609,
    y1: 128.312,
    x2: 130.649,
    y2: 201.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_908_1761",
    x1: 123.814,
    y1: 125.366,
    x2: 128.187,
    y2: 204.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_908_1761",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.519 164.019) rotate(90) scale(60.8648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488271,
    stopColor: "#DEECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750311,
    stopColor: "#DEE5F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_908_1761",
    x1: 96.709,
    y1: 216.498,
    x2: 222.479,
    y2: 208.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_908_1761",
    x1: 139.961,
    y1: 142.37,
    x2: 142.41,
    y2: 186.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_908_1761",
    x1: 162.395,
    y1: 161.038,
    x2: 225.496,
    y2: 157.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_908_1761",
    x1: 154.629,
    y1: 168.863,
    x2: 166.624,
    y2: 168.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTeam);
export default __webpack_public_path__ + "static/media/manage-team.58de202ae5d7a5e93e04c9e4ed829070.svg";
export { ForwardRef as ReactComponent };